import { InfoCircle } from "@untitledui/icons";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";

interface SmartUnboxGroupBadgeProps {
  className?: string;
  showLabel?: boolean;
}

/**
 * Badge shown under collaboration names in the table when they are part of a Smart Unbox group.
 * Includes an info tooltip explaining the grouping functionality.
 */
export const SmartUnboxGroupBadge = ({ className, showLabel = true }: SmartUnboxGroupBadgeProps) => {
  return (
    <span className={`inline-flex items-center gap-1 text-xs text-tertiary ${className ?? ""}`}>
      {showLabel && <span>Smart Unbox group</span>}
      <Tooltip
        title="Grouped collaborations"
        description="Identical collaborations are automatically grouped together. Click the plus icon to see an individual collaboration in more detail."
        placement="top"
      >
        <TooltipTrigger className="inline-flex items-center">
          <InfoCircle className="w-4 h-4 text-quaternary hover:text-tertiary cursor-help transition-colors" />
        </TooltipTrigger>
      </Tooltip>
    </span>
  );
};
